<template>
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

    <div v-if="value">
      <div class="columns is-multiline">

        <!-- 내부 플러그인 관리 -->
        <div class="column is-8">
          <div class="box">
            <admin-box-item title="구매 적립금 설정" subtitle="구매 확정 시 지급하는 적립금을 설정합니다.">
              <div class="column is-full">
                <admin-form-item label="적립금 사용 설정">
                  <lp-radio :val.sync="value.enable_order"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.enable_order">
                <!--<admin-form-item label="적립률 설정">
                  <lp-radio :val.sync="value.point_type"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'기본 적립률', value:0}, /*{label:'결제 방식에 따라 차등 지급', value:1}*/]"></lp-radio>
                </admin-form-item>-->

                <!-- 기본 적립률 -->
                <div class="flex align-center"
                     style="margin-bottom:12px"
                     v-if="value.point_type===0">
                  <span>상품 금액의</span>
                  <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           style="width:100px"
                           v-model="value.base_rate"
                           @input="e => setFloat(e, 'base_rate', 4)"
                           type="number"
                           v-if="value.base_type===0">
                    <input class="input full has-text-right"
                           style="width:100px"
                           v-model="value.base_price"
                           @input="e => setNumber(e, 'base_price', 10)"
                           type="number"
                           v-if="value.base_type===1">
                  </span>
                  <span class="select">
                    <select v-model="value.base_type"
                            @change="e => value.base_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                </div>

                <!-- 결제 방식에 따라 차등 지급 -->
                <div v-if="value.point_type===1">
                  <div class="flex align-center"
                       style="margin-bottom:12px">
                    <span style="width:110px">가상계좌</span>
                    <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.vbank_rate"
                           @input="e => setFloat(e, 'vbank_rate', 4)"
                           step="0.1"
                           type="number"
                           v-if="value.vbank_type===0">
                    <input class="input full has-text-right"
                           v-model="value.vbank_price"
                           @input="e => setNumber(e, 'vbank_price', 10)"
                           type="number"
                           v-if="value.vbank_type===1">
                  </span>
                    <span class="select">
                    <select v-model="value.vbank_type"
                            @change="e => value.vbank_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  </div>

                  <div class="flex align-center"
                       style="margin-bottom:12px">
                    <span style="width:110px">카드 결제</span>
                    <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.card_rate"
                           @input="e => setFloat(e, 'card_rate', 4)"
                           step="0.1"
                           type="number"
                           v-if="value.card_type===0">
                    <input class="input full has-text-right"
                           v-model="value.card_price"
                           @input="e => setNumber(e, 'card_price', 10)"
                           type="number"
                           v-if="value.card_type===1">
                  </span>
                    <span class="select">
                    <select v-model="value.card_type"
                            @change="e => value.card_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  </div>

                  <div class="flex align-center"
                       style="margin-bottom:12px">
                    <span style="width:110px">휴대폰 결제</span>
                    <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.phone_rate"
                           @input="e => setFloat(e, 'phone_rate', 4)"
                           type="number"
                           step="0.1"
                           v-if="value.phone_type===0">
                    <input class="input full has-text-right"
                           v-model="value.phone_price"
                           @input="e => setNumber(e, 'phone_price', 10)"
                           type="number"
                           v-if="value.phone_type===1">
                  </span>
                    <span class="select">
                    <select v-model="value.phone_type"
                            @change="e => value.phone_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  </div>

                  <div class="flex align-center"
                       style="margin-bottom:12px">
                    <span style="width:110px">실시간 계좌 이체</span>
                    <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.trans_rate"
                           @input="e => setFloat(e, 'trans_rate', 4)"
                           step="0.1"
                           type="number"
                           v-if="value.trans_type===0">
                    <input class="input full has-text-right"
                           v-model="value.trans_price"
                           @input="e => setNumber(e, 'trans_price', 10)"
                           type="number"
                           v-if="value.trans_type===1">
                  </span>
                    <span class="select">
                    <select v-model="value.trans_type"
                            @change="e => value.trans_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  </div>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!--<div class="box" v-if="value.enable">
            <admin-box-item title="후기 작성 적립금 설정" subtitle="상품 후기 작성 시 지급하는 적립금을 설정합니다."
                            :title-flex="true">
              <lp-radio :val.sync="value.review_enable"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
              <div v-if="value.review_enable" style="margin-top: 12px">
                <admin-form-item label="적립 금액 설정">
                  <div class="flex align-center" style="margin-bottom:12px">
                    <span>텍스트만 있는 경우</span>
                    <span style="margin:0 4px"><input class="input full has-text-right"
                                                      :min="0"
                                                      v-model="value.review_text_price"
                                                      @input="e => setNumber(e, 'review_text_price', 10)"
                                                      type="number"></span>
                    <span>원</span>
                  </div>
                  <div class="flex align-center" style="margin-bottom:12px">
                    <span>이미지 첨부한 경우</span>
                    <span style="margin:0 4px"><input class="input full has-text-right"
                                                      :min="0"
                                                      v-model="value.review_img_price"
                                                      @input="e => setNumber(e, 'review_img_price', 10)"
                                                      type="number"></span>
                    <span>원</span>
                  </div>
                </admin-form-item>
                <admin-form-item label="지급 방식 설정">
                  <lp-radio :val.sync="value.review_payment_type"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'수동지급',value:0}, {label:'자동지급', value:1}]"></lp-radio>
                  <span class="desc1" v-if="value.review_payment_type===0">
                    <span class="unselect"
                          style="text-decoration: underline"
                          @click="routerPush(getPath('product/review/all'))">상품 후기/문의 관리 > 상품 후기 관리</span>
                    에서 후기를 직접 확인하고 지급합니다.</span>
                  <span class="desc1" v-else-if="value.review_payment_type===1">설정한 적립금이 자동으로 지급됩니다.</span>
                </admin-form-item>
                <admin-form-item label="후기 게시글 삭제 시 적립금 차감">
                  <lp-radio :val.sync="value.enable_return_review_point"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                </admin-form-item>
              </div>
            </admin-box-item>
          </div>-->

          <div class="box" v-if="value.enable">
            <admin-box-item title="특별 적립금 설정">
              <div>
                <lp-check-bool :checked-val.sync="value.enable_sign"
                               label="신규 회원가입 시 적립금 지급 "></lp-check-bool>
              </div>
              <div class="flex align-center"
                   style="margin: 12px 0px;margin-left:16px"
                   v-if="value.enable_sign">
                <span style="margin:0 4px"><input class="input full has-text-right"
                                                  style="width:100px"
                                                  v-model="value.sign_price"
                                                  @input="e => setNumber(e, 'sign_price', 10)"
                                                  type="number"></span>
                <span>원 적립</span>
              </div>
            </admin-box-item>
          </div>

          <!--<div class="box" v-if="value.enable">
            <admin-box-item title="적립금 사용 제한 설정">
              <div>
                <lp-check-bool :checked-val.sync="value.enable_order"
                               label="상품 주문 금액 조건 설정"></lp-check-bool>
              </div>
              <div class="flex align-center" style="margin:12px 0" v-if="value.enable_order">
                <span>상품 주문 합계액 최소</span>
                <span style="margin:0 4px"><input class="input full has-text-right"
                                                  v-model="value.order_price"
                                                  @input="e => setNumber(e, 'order_price', 10)"
                                                  type="number"></span>
                <span>원 이상일 때 사용 가능</span>
              </div>
              <div style="padding-top:12px">
                <lp-check-bool :checked-val.sync="value.enable_accumulation"
                               label="누적 적립금 조건 설정"></lp-check-bool>
              </div>
              <div class="flex align-center"style="margin:12px 0" v-if="value.enable_accumulation">
                <span>누적된 적립금이 최소</span>
                <span style="margin:0 4px"><input class="input full has-text-right"
                                                  v-model="value.accumulation_price"
                                                  @input="e => setNumber(e, 'accumulation_price', 10)"
                                                  type="number"></span>
                <span>원 이상일 때 사용 가능</span>
              </div>
            </admin-box-item>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../module/common/LpRadio";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {
    name: 'point-setting',
    components: {
      LpCheckBool,
      AdminFormItem,
      LpRadio},
    data() {
      return {
        value: undefined,
      }
    },
    created() {
      this.$axios.get('admin/point/setting').then(res=>{
        this.value = res.data;
      })
    },
    methods: {
      // 인풋 숫자 입력시 max_length 조건에 맞춰서 return
      setFloat(e, attr, max_length){
        let max = 100;
        let min = 0;
        let val = parseFloat(e.target.value.substr(0,max_length));
        if(max<val) val = max;
        if(val<min) val= min;
        this.value[attr] =  val;
      },
      setNumber(e, attr, max_length){
        this.value[attr] = parseInt(e.target.value.substr(0,max_length));
      },
      save() {
        this.$axios.patch('admin/point/setting', {
          point_setting: this.value
        }).then(res=>{
          this.saveServiceGuide('point_coupon');
          if(res.status===200) this.toast('저장되었습니다.');
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .desc1
    color #9A9A9A
    font-size 12px
</style>

